import type { Terminal } from '~/modules/terminals/model'

export const initialTerminal: Terminal = {
  id: '',
  name: '',
  businessUnitCode: '',
  data: {
    address: {
      isBusiness: false,
      countryCode: 'NL',
      postalCode: '',
      city: '',
      street: '',
      houseNumber: '',
      houseNumberSuffix: '',
    },
    contactPerson: {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
    },
  },
  useCompanyAddressBook: false,
  useSharedShipments: false,
  useSharedDrafts: false,
  useAdvancedParcelType: false,
  useSharedTickets: false,
  useSharedImportSchemas: false,
}
